import axios from "axios";
import { auth } from "@/lib/firebase";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach fresh Firebase ID token to every request when a user is signed in.
api.interceptors.request.use(async (config) => {
  try {
    const user = auth?.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_e) { /* ignore token retrieval errors */ }
  return config;
});

export { API, BASE };
export default api;
